import { render, staticRenderFns } from "./Aside.vue?vue&type=template&id=a5163782&scoped=true&"
import script from "./Aside.vue?vue&type=script&setup=true&lang=js&"
export * from "./Aside.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Aside.vue?vue&type=style&index=0&id=a5163782&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5163782",
  null
  
)

export default component.exports